export const CloseIcon = ({ size = 15, color = "#f97316" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="3 2 20 20"
    stroke={color}
    strokeWidth="2.5"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="19" y1="7" x2="7" y2="19" />
    <line x1="7" y1="7" x2="19" y2="19" />
  </svg>
);